type WithoutEmpty<T> = T extends '' ? never : T

/**
 * Many autogenerated Storyblok types contain empty string as a possible value.
 * This helper function replaces this value too undefined to use fallback to default property for components.
 * Example {@link StoryblokButtonV2Type} `color` property.
 */
export const cmsExcludeEmptyString = <T extends string | undefined>(
  value: T,
): WithoutEmpty<T> | undefined =>
  value === '' ? undefined : (value as WithoutEmpty<T>)
